export enum ProductCategories {
  door = 'Door',
  doorService = 'Door Service',
  elevation = 'Elevation',
  frame = 'Frame',
  frameService = 'Frame Service'
}
